import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { environment } from '@environments/environment';
import { PinMode, SignCheckPinRequest } from '@models/index.model';
import { LoadingService, SigntrustService } from '@services/index.service';
import { filter, fromEvent } from 'rxjs';

@Component({
    selector: 'app-dialog-confirm-pin-reason',
    templateUrl: './dialog-confirm-pin-reason.component.html',
    styles: [],
    standalone: false
})
export class DialogConfirmPinReasonComponent implements OnInit, OnDestroy {
  public isMobile: boolean;
  public loader: boolean = false;
  result = {
    pin: null,
    reason: null
  }
  hide: boolean = true;

  constructor(
    public dialogRef: MatDialogRef<DialogConfirmPinReasonComponent>,
    private _loading: LoadingService,
    private _signtrustServ: SigntrustService,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    this.isMobile = environment.platform === 'mobile';
  }

  ngOnInit() {
    this._loading.hideGlobalLoading();
    fromEvent(document, 'keyup').pipe(filter(keyup => (keyup as KeyboardEvent).key === 'Enter')).subscribe(() => {
      if (
        ((this.result.pin?.trim() && this.result.pin?.length > 3) && this.result.reason?.trim())
        || ((this.result.pin?.trim() && this.result.pin?.length > 3) && !this.data.needReason)
        || ((this.data.pinMode === PinMode.NoPIN) && this.result.reason?.trim())) {
        this.checkPin();
      }
    });
  }

  checkPin() {
    if (this.data.pinMode !== PinMode.NoPIN) {
      this.loader = true;
      const checkPinRequest: SignCheckPinRequest = {
        selectedCertId: this.data.certificateHandler,
        pin: this.result.pin
      }
      this._signtrustServ
      .checkPin(checkPinRequest)
      .subscribe((res: any) => {
        if (res.data === 0) {
          this.onSign();
        }
        this.loader = false;
      }, error => {
        console.error(error);
        this.loader = false;
      });
    } else {
      this.onSign();
    }
  }

  onSign() {
    this._loading.showGlobalLoading();
    this.dialogRef.close(this.result);
  }

  onCancel() {
    this.dialogRef.close(false);
  }

  ngOnDestroy(): void {
    this.result = {
      pin: null,
      reason: null
    }
  }
}
